import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueFire from 'vuefire'
// import firebaseui from 'firebaseui'
import firebase from 'firebase/app'
import 'firebase/firestore'
import config from './config'
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './styles/global.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import standards_import from './data/standards.json'
import store from './store'

Vue.config.productionTip = false
Vue.use(VueFire)
firebase.initializeApp(config.firebase)

// Vue Material : Note, it's possible to import individual components, but not yet. See: https://github.com/vuematerial/vue-material/issues/1182
Vue.use(VueMaterial)

export const standards = standards_import;
export const standards_dict = new Map(standards.map(standard =>{return [standard.benchmark_number, standard]}));
const settings = {timestampsInSnapshots: true};
export const db = firebase.firestore();
db.settings(settings)
new Vue({
  router,
  store,
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      store.commit('userUpdated', user)
      if(!user)
        router.push('/')
     });
    },  
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js